import React, { Component } from "react";
import "./index.scss";

export default class Logo extends Component {
  render() {
    return (
      <svg
        id="sook-logo"
        xmlns="http://www.w3.org/2000/svg"
        width="210.145"
        height="54.702"
        viewBox="0 0 210.145 54.702"
      >
        <g id="Group_1" data-name="Group 1" transform="translate(0)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M530.79,375.821h-54.7v-54.7h54.7Zm-51.815-2.887H527.9V324.006H478.975Z"
            transform="translate(-476.088 -321.119)"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M543.923,410.372a31,31,0,0,1-7.491-.776,14.7,14.7,0,0,1-4.988-2.154,8.325,8.325,0,0,1-2.795-3.26,9.608,9.608,0,0,1-.873-4.095v-.5H534.8v.349a4.819,4.819,0,0,0,.446,2.077,4.047,4.047,0,0,0,1.514,1.65,8.506,8.506,0,0,0,2.814,1.087,20.45,20.45,0,0,0,4.347.388,31.422,31.422,0,0,0,4.58-.272,9.841,9.841,0,0,0,2.775-.757A3.107,3.107,0,0,0,552.637,403a2.543,2.543,0,0,0,.369-1.32,2.222,2.222,0,0,0-1.067-2,7.812,7.812,0,0,0-2.834-.99,31.2,31.2,0,0,0-4.017-.408q-2.252-.1-4.6-.252t-4.6-.485a14.6,14.6,0,0,1-4.018-1.145,7.218,7.218,0,0,1-2.834-2.251,6.085,6.085,0,0,1-1.067-3.726,6.843,6.843,0,0,1,.776-3.2,6.733,6.733,0,0,1,2.62-2.6,16.279,16.279,0,0,1,4.891-1.766,36.888,36.888,0,0,1,7.627-.66,30.135,30.135,0,0,1,7.375.776,15.012,15.012,0,0,1,4.93,2.116,8.271,8.271,0,0,1,2.775,3.144,8.754,8.754,0,0,1,.873,3.862v.31h-7.026v-.31a3.7,3.7,0,0,0-.446-1.766,3.986,3.986,0,0,0-1.494-1.475,9.259,9.259,0,0,0-2.756-1.029,19.5,19.5,0,0,0-4.231-.388,30.016,30.016,0,0,0-4.464.272,10.044,10.044,0,0,0-2.717.737,3.14,3.14,0,0,0-1.339,1.048,2.278,2.278,0,0,0-.369,1.242,1.876,1.876,0,0,0,1.067,1.747,8.471,8.471,0,0,0,2.834.834,35,35,0,0,0,4.017.31q2.251.058,4.6.213t4.6.5a14.207,14.207,0,0,1,4.018,1.2,7.475,7.475,0,0,1,2.833,2.309,6.316,6.316,0,0,1,1.068,3.823,7.453,7.453,0,0,1-.8,3.377,7.091,7.091,0,0,1-2.678,2.775,15.708,15.708,0,0,1-4.968,1.863A36.442,36.442,0,0,1,543.923,410.372Z"
            transform="translate(-516.553 -368.931)"
          />
        </g>
        <g id="Group_2" data-name="Group 2" transform="translate(51.815)">
          <path
            id="Path_3"
            data-name="Path 3"
            d="M769.422,375.821h-54.7v-54.7h54.7Zm-51.815-2.887h48.927V324.006H717.607Z"
            transform="translate(-714.72 -321.119)"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M775.608,410.372a25.637,25.637,0,0,1-7.841-1.087,16.6,16.6,0,0,1-5.648-2.989,12.3,12.3,0,0,1-3.415-4.483,13.977,13.977,0,0,1,0-11.082,12.356,12.356,0,0,1,3.415-4.464,16.626,16.626,0,0,1,5.648-2.989,28.829,28.829,0,0,1,15.682,0,16.625,16.625,0,0,1,5.648,2.989,12.363,12.363,0,0,1,3.416,4.464,13.981,13.981,0,0,1,0,11.082A12.308,12.308,0,0,1,789.1,406.3a16.6,16.6,0,0,1-5.648,2.989A25.641,25.641,0,0,1,775.608,410.372Zm0-5.628a16.129,16.129,0,0,0,4.871-.66,10.371,10.371,0,0,0,3.474-1.805,7.414,7.414,0,0,0,2.1-2.678,8.231,8.231,0,0,0,0-6.637,7.428,7.428,0,0,0-2.1-2.678,10.39,10.39,0,0,0-3.474-1.8,18.31,18.31,0,0,0-9.743,0,10.383,10.383,0,0,0-3.474,1.8,7.428,7.428,0,0,0-2.1,2.678,8.231,8.231,0,0,0,0,6.637,7.414,7.414,0,0,0,2.1,2.678,10.364,10.364,0,0,0,3.474,1.805A16.126,16.126,0,0,0,775.608,404.744Z"
            transform="translate(-748.257 -368.931)"
          />
        </g>
        <g id="Group_3" data-name="Group 3" transform="translate(103.629)">
          <path
            id="Path_5"
            data-name="Path 5"
            d="M1008.054,375.821h-54.7v-54.7h54.7Zm-51.815-2.887h48.927V324.006H956.239Z"
            transform="translate(-953.352 -321.119)"
          />
          <path
            id="Path_6"
            data-name="Path 6"
            d="M1014.24,410.372a25.637,25.637,0,0,1-7.841-1.087,16.6,16.6,0,0,1-5.648-2.989,12.3,12.3,0,0,1-3.416-4.483,13.98,13.98,0,0,1,0-11.082,12.359,12.359,0,0,1,3.416-4.464,16.626,16.626,0,0,1,5.648-2.989,28.829,28.829,0,0,1,15.681,0,16.624,16.624,0,0,1,5.648,2.989,12.365,12.365,0,0,1,3.416,4.464,13.981,13.981,0,0,1,0,11.082,12.311,12.311,0,0,1-3.416,4.483,16.6,16.6,0,0,1-5.648,2.989A25.642,25.642,0,0,1,1014.24,410.372Zm0-5.628a16.129,16.129,0,0,0,4.871-.66,10.372,10.372,0,0,0,3.474-1.805,7.414,7.414,0,0,0,2.1-2.678,8.231,8.231,0,0,0,0-6.637,7.427,7.427,0,0,0-2.1-2.678,10.39,10.39,0,0,0-3.474-1.8,18.31,18.31,0,0,0-9.742,0,10.383,10.383,0,0,0-3.474,1.8,7.428,7.428,0,0,0-2.1,2.678,8.233,8.233,0,0,0,0,6.637,7.414,7.414,0,0,0,2.1,2.678,10.364,10.364,0,0,0,3.474,1.805A16.124,16.124,0,0,0,1014.24,404.744Z"
            transform="translate(-986.889 -368.931)"
          />
        </g>
        <g id="Group_4" data-name="Group 4" transform="translate(155.444)">
          <path
            id="Path_7"
            data-name="Path 7"
            d="M1246.685,375.821h-54.7v-54.7h54.7Zm-51.814-2.887H1243.8V324.006H1194.87Z"
            transform="translate(-1191.983 -321.119)"
          />
          <path
            id="Path_8"
            data-name="Path 8"
            d="M1279.417,411.687h-9.238l-13.43-13.2v13.2h-6.909V384.516h6.909v12.46l12.964-12.46h8.928L1264.511,397.6Z"
            transform="translate(-1237.277 -370.75)"
          />
        </g>
      </svg>
    );
  }
}
